import React from "react"

export const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M1 11L11.0001 1" stroke="#9693B0" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.0001 11L1 1" stroke="#9693B0" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
